import { Dayjs } from 'dayjs'
import { atom } from 'jotai'

import dayjs from '../../common/utils/dayjs/dayjs'

export const defaultSelectedDate = dayjs()
export const selectedDateAtom = atom<Dayjs>(defaultSelectedDate)

export const selectedAppointmentIdAtom = atom<number | undefined>(undefined)

export const selectedPractitionerIdAtom = atom<number | undefined>(undefined)

export const practitionerModalPractitionerId = atom<number | undefined>(undefined)
